import { KEY } from "./reducer";

export const getState = (state) => state[KEY] || {};

export const getGroups = (state) => getState(state).groups || {};

export const getGroupById = (state, id) => getGroups(state)[id];

export const getQuery = (state) => getState(state).query || "";
